import { X } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { SidebarNav } from './SidebarNav';
import { SidebarFooter } from './SidebarFooter';
import { sidebarConfig } from './sidebarConfig';

export function Sidebar() {
  const { isCollapsed, isMobileOpen, setMobileOpen } = useSidebar();

  return (
    <>
      {/* Mobile backdrop */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar - always fixed */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50
          flex flex-col h-screen
          bg-slate-900
          border-r border-slate-800
          transition-all duration-300 ease-in-out
          ${isCollapsed ? 'w-16' : 'w-64'}
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        {/* Header - fixed height, same as TopBar */}
        <div
          className={`
            h-14 flex-shrink-0 flex items-center border-b border-slate-800
            ${isCollapsed ? 'justify-center px-2' : 'justify-between px-4'}
          `}
        >
          {/* Logo */}
          <div className={`flex items-center gap-2 ${isCollapsed ? 'justify-center' : ''}`}>
            <img
              src="/logo.png"
              alt="TARK"
              className="h-8 w-8 flex-shrink-0"
            />
            {!isCollapsed && (
              <span className="text-lg font-bold text-white">TARK Admin</span>
            )}
          </div>

          {/* Mobile close button */}
          {!isCollapsed && (
            <button
              onClick={() => setMobileOpen(false)}
              className="lg:hidden p-1.5 rounded-lg text-slate-400 hover:bg-slate-800 hover:text-white transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          )}
        </div>

        {/* Navigation - scrollable */}
        <SidebarNav sections={sidebarConfig} />

        {/* Footer with user info - fixed at bottom */}
        <SidebarFooter />
      </aside>
    </>
  );
}
